var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.10178 4.1055C6.94622 2.59067 7.36843 1.83325 7.99967 1.83325C8.63092 1.83325 9.05313 2.59067 9.89756 4.1055L10.116 4.49741C10.356 4.92788 10.476 5.14311 10.663 5.28512C10.8501 5.42714 11.0831 5.47985 11.5491 5.58528L11.9733 5.68127C13.6131 6.05229 14.433 6.2378 14.6281 6.86507C14.8231 7.49235 14.2642 8.14597 13.1463 9.4532L12.8571 9.7914C12.5394 10.1629 12.3806 10.3486 12.3091 10.5784C12.2376 10.8082 12.2617 11.056 12.3097 11.5516L12.3534 12.0028C12.5224 13.747 12.6069 14.6191 12.0962 15.0067C11.5856 15.3944 10.8179 15.0409 9.28256 14.334L8.88535 14.1511C8.44906 13.9503 8.23091 13.8498 7.99967 13.8498C7.76844 13.8498 7.55029 13.9503 7.114 14.1511L6.71679 14.334C5.18146 15.0409 4.41379 15.3944 3.90311 15.0067C3.39242 14.6191 3.47693 13.747 3.64594 12.0029L3.68966 11.5516C3.73769 11.056 3.76171 10.8082 3.69025 10.5784C3.61879 10.3486 3.45996 10.1629 3.14229 9.7914L2.85307 9.4532C1.73517 8.14597 1.17622 7.49235 1.37129 6.86507C1.56635 6.2378 2.38625 6.05229 4.02603 5.68127L4.45027 5.58528C4.91624 5.47985 5.14923 5.42714 5.3363 5.28512C5.52338 5.14311 5.64336 4.92788 5.88332 4.49741L6.10178 4.1055Z",
    stroke: "#FE8016",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.1b271f2181a9d2bfccc3a7caf8b27846.svg";
export { ForwardRef as ReactComponent };